module.exports = __webpack_public_path__ + "assets/images/template/project/animals/tablet.svg?v=663edfcf";